import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import AdmissionContext from "../AdmissionContext";

class StepperView extends Component {
  static contextType = AdmissionContext;

  render() {
    const {activeStep, admission, newEnrolle} = this.context;
    // console.log("StepperView");
    // console.log(this.context);

    if (!admission) {
      return null;
    } else {
      if (newEnrolle) {
        return (
          <Box>
            <Stepper activeStep={activeStep} alternativeLabel>
              <Step>
                {/* 0 */}
                <StepLabel>Course/Program</StepLabel>
              </Step>
              <Step>
                {/* 1 */}
                <StepLabel>Personal Information</StepLabel>
              </Step>
              <Step>
                {/* 2 */}
                <StepLabel>Address</StepLabel>
              </Step>
              <Step>
                {/* 3 */}
                <StepLabel>Contact</StepLabel>
              </Step>
              <Step>
                {/* 4 */}
                <StepLabel>School Record</StepLabel>
              </Step>
              <Step>
                {/* 5 */}
                <StepLabel>Attach Documents</StepLabel>
              </Step>
              <Step>
                {/* 6 */}
                <StepLabel>Others</StepLabel>
              </Step>
              <Step>
                {/* 7 */}
                <StepLabel>Finish</StepLabel>
              </Step>
            </Stepper>
          </Box>
        );
      } else {
        return (
          <Box>
            <Stepper activeStep={activeStep} alternativeLabel>
              <Step>
                <StepLabel>Course/Program</StepLabel>
              </Step>
              <Step>
                <StepLabel>Personal Information</StepLabel>
              </Step>
              <Step>
                <StepLabel>Address</StepLabel>
              </Step>
              <Step>
                <StepLabel>Contact</StepLabel>
              </Step>
              <Step>
                <StepLabel>Guardian</StepLabel>
              </Step>
              <Step>
                <StepLabel>Member/Groups</StepLabel>
              </Step>
            </Stepper>
          </Box>
        );
      }
    }
  }
}

export default StepperView;
